import React, { useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";

import { deriveLineFunction, useAnimatedPath } from "./utils";
import chroma from "chroma-js";
import { line, curve, curveBasis } from "d3-shape";


const AnimatedLinePath = ({ data, toggle, xScale, yScale }) => {


    const colors = ['rgb(10,100,150)', 'rgb(10,240,120)', 'yellow', 'rgb(240,10,10)']

    const color = chroma.scale(colors);
    // const line = deriveLineFunction(xScale, yScale, index);
    const lineGenerator = line().curve(curveBasis)
        .x(index => xScale((index.x0 + index.x1) / 2))
        .y(index => yScale(index.length));

    const animationStrokeProps = useAnimatedPath({ toggle, delay: 200, color: "black" });

    const animationFillStyle = useSpring({
        //fill: toggle ? color(index.value) : "#fff",
        fill: toggle ? "green" : "#fff",


        delay: 900
    });

    return (
        <animated.path {...animationStrokeProps}

            style={{
                ...animationStrokeProps.style,
                ...animationFillStyle
            }}
            strokeWidth={3}
            d={lineGenerator(data)}
        />
    )
}

export default AnimatedLinePath;
